export default "__VITE_ASSET__BfkXg_my__"